module.exports = __webpack_public_path__ + "static/media/death-zone.6db7c7ec.svg";